<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/project/list'}">Gestion des parcours</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.project.contact_id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editProject.sortie', params: { projectId: this.project.id } }">Fiche de Sortie</a>
        </div>
        <h1>Parcours de {{ project.contact_firstname }} {{ project.contact_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithProject', params: { contactId: project.contact_id, projectId: project.id } }">Ajouter un rendez-vous</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editProject', params: { projectId: project.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningProject', params: { projectId: project.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editProject.sortie', params: { projectId: project.id }}">Fiche de sortie</a>
        </li>
      </ul>
    </div>
  </div>
  <div>
    <hr>
    <!--<h2 class="card-title">{{ editionName }}</h2>-->
    <validator name="validator">
      <form novalidate>
        <div class="card-block">
          <fieldset>
            <div class="row">
                      <div class="col-sm-12">
                          <!-- Date de sortie -->
                          <div class="form-group">
                              <label for="exit_date">Date de sortie : {{ project.exit_date }}</label>
                          </div>
                      </div>
                     <div class="col-sm-12">
                        <div class="col-sm-6">
                            <!-- Motif sortie -->
                                <label for="fs_exit_reason_id">Motif de sortie</label>
                                <select
                                  id      = "fs_exit_reason_id"
                                  name    = "fs_exit_reason_id"
                                  v-model = "project.fs_exit_reason_id"
                                  class   = "form-control"
                                >
                                    <option v-for="motifSortie in sorties" :value="motifSortie.id">{{ motifSortie.name }}</option>
                                </select>
                        </div>
                        <div class="col-sm-6">
                            <!-- Autre -->
                                <label for="montant">Précision autre</label>
                                <input class="form-control"
                                    id                         = "fs_exit_reason_precisions"
                                    type                       = "text"
                                    v-model                    = "project.fs_exit_reason_precisions"
                                >
                        </div>
                     </div>
                     <div class="col-sm-12">
                        <div class="col-sm-6">
                            <!-- montant 3 mois -->
                                <label for="fs_amount_incomes_for_last_3_months">Montant total des revenus des 3 derniers mois</label>
                                <input class="form-control"
                                    id                         = "fs_amount_incomes_for_last_3_months"
                                    type                       = "text"
                                    v-model                    = "project.fs_amount_incomes_for_last_3_months"
                                >
                        </div>
                        <div class="col-sm-6">
                            <!-- Situation 6 mois -->
                              <label for="fs_status_6_months_later">Situation 6 mois après la sortie</label>
                                  <input class="form-control"
                                        id                         = "fs_status_6_months_later"
                                        type                       = "text"
                                        v-model                    = "project.fs_status_6_months_later"
                                  >
                        </div>
                       <div class="col-sm-6">
                            <!-- Perennite 3 ans -->
                            <div class="">
                              <switch :value.sync = "project.fs_longevity_up_to_3_years">Perennité à 3 ans</switch>
                            </div>
                        </div>
                     </div>
			<div class="col-sm-12">
				<legend>Observations</legend>
				<div class="col-sm-12">
		                      <textarea rows="10" id="fs_observations" v-model="project.fs_observations" placeholder="" class="form-control"></textarea>
				</div>
			        <div class="card-block">
			        	<div class="text-xs-right">
						<!--<button class="btn btn-default" v-on:click.prevent="cancel()">Fermer</button>-->
						<button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
					</div>
				</div>
			</div>
          </fieldset>
        </div>
      </form>
    </validator>
    </div>
</template>
<script>
    // Required for datepicker
    import moment from 'moment'
    // Options for datepicker
    import { datepickerOptions } from 'src/options/date'
    // Required for datepicker
    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'

    import { Switch } from 'mint-ui'

    // Vuex
    import { getSortie, addSortie, editSortie, deleteSortie } from 'src/vuex/actions/sortieActions'
    import { getProject } from 'src/vuex/actions/projectActions'
    import { project, sortie, sorties, sortieRequestError as requestError } from 'src/vuex/getters'

    // jQuery
    import $ from 'jquery'

    export default {
      vuex: {
        getters: {
          sortie,
          sorties,
          project,
          requestError
        },
        actions: {
          getProject,
          getSortie,
          addSortie,
          editSortie,
          deleteSortie
        }
      },
      data () {
        return {
          sortie: null,
          sortieUpdate: null,
          datepickerOptions
        }
      },
      validators: {
        list: function (val) {
          return /^[1-9]+$/.test(val)
        }
      },
      computed: {
        name: function () {
          if (Number.isInteger(this.project.id)) {
            return this.project.contact_firstname + ' ' + this.project.contact_lastname
          } else {
            return 'Parcours'
          }
        },
        editionName: function () {
          return (this.project !== null && Number.isInteger(this.project.id)) ? 'Edition' : 'Création'
        }
      },
      methods: {
        edit: function (project) {
          this.project = JSON.parse(JSON.stringify(project))
          this.sortieUpdate = project
        },
        remove: function (sortie) {
          this.deleteSortie(sortie)
        },
        create: function () {
          this.sortie = {}
          this.sortieUpdate = null
        },
        cancel: function () {
          this.sortie = null
          this.sortieUpdate = null
        },
        save: function () {
          if (this.project.fs_exit_reason_id !== '') {
            if (Number.isInteger(this.project.id) === true) {
              this.editSortie(this.sortieUpdate, this.project)
            }
            if (this.error === false) {
              this.sortie = null
            }
          }
        },
        updateLongevityTimer: function () {
          setTimeout(this.updateLongevity, 100)
        },
        updateLongevity () {
          this.project.fs_longevity_up_to_3_years = $('.fs_longevity_up_to_3_years .mint-switch-input').is(':checked')
        }
      },
      components: { 'date-picker': datePicker, Switch },
      ready () {
        let vm = this
        this.getProject(this.$route.params.projectId)
          .then(() => {
            vm.project.exit_date = moment(vm.project.exit_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            if (vm.project.exit_date === 'Invalid date') {
              vm.project.exit_date = ''
            }
          })
        this.getSortie(this.$route.params.projectId)
      }
    }
</script>




// WEBPACK FOOTER //
// ProjectEditSortie.vue?7713c5f9